import { createSlice } from "@reduxjs/toolkit";
import KEYS from "src/constants";
import UserModel from "src/models/UserModel";
import { isProgramId } from "src/utility/utility";
import { RootState } from "..";
import Config from "../../config";

export interface AuthState {
  user: Partial<UserModel> | null;
  accessToken: string | null;
  rememberMe: boolean;
  programId: string | null;
  features: string[] | null;
}

export const loadUserFromLocalStorage = (): AuthState => {
  const token = localStorage.getItem(KEYS.AUTH_TOKEN);
  return {
    programId: null,
    user: null,
    accessToken: token,
    rememberMe: false,
    features: ["transactions"],
  };
};

const initialState: AuthState = {
  user: null,
  accessToken: null,
  rememberMe: false,
  programId: null,
  features: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {
    setProgram: (state, action) => {
      const programId = action.payload.programId;
      state.programId = programId;
      localStorage.setItem(KEYS.PROGRAM_ID, programId ?? "0");

      if (isProgramId(programId)) {
        state.features = Config[programId].features;
      } else {
        state.features = null;
      }
    },
    login: (state, action) => {
      const user: Partial<UserModel> = {
        Client: action.payload.user.Client,
        permission: action.payload.user.permission,
      };
      state.user = user;
      state.accessToken = action.payload.accessToken;
      state.rememberMe = action.payload.rememberMe;

      if (action.payload.rememberMe) {
        localStorage.setItem(KEYS.AUTH_TOKEN, String(state.accessToken));
        return;
      }

      sessionStorage.setItem(KEYS.AUTH_TOKEN, String(state.accessToken));
    },
    logout: (state) => {
      state.user = null;
      state.accessToken = null;
      state.rememberMe = false;
      sessionStorage.removeItem(KEYS.PROGRAM_ID);
      sessionStorage.removeItem(KEYS.AUTH_TOKEN);
      localStorage.removeItem(KEYS.AUTH_TOKEN);
      localStorage.removeItem(KEYS.PROGRAM_ID);
      window.location.replace("/program");
    },
  },
});

export const { login, logout, setProgram } = authSlice.actions;

export const accessTokenSelector = (state: RootState) =>
  state?.auth?.accessToken;

export const getProgram = (state: RootState) => {
  if (!state.auth.programId) return null;
  return Config[(state.auth.programId as keyof typeof Config) ?? "0"];
};

export default authSlice.reducer;
